document.addEventListener('DOMContentLoaded', function () {

  /* サイドメニュー開閉 */
  const sideToggles = document.querySelectorAll('.mecu-side__toggle');

  sideToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const subMenu = toggle.nextElementSibling;

      toggle.classList.toggle('is-open');
      if (subMenu) {
        subMenu.classList.toggle('is-open');
      }
    });
  });


  /* オススメ商品タブ */
  const recommendTabs = document.querySelectorAll('.mecu-recommend-tab');
  const recommendPanels = document.querySelectorAll('.mecu-recommend-panel');

  recommendTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const target = tab.dataset.tab;

      recommendTabs.forEach(function(item) {
        item.classList.remove('is-active');
      });

      recommendPanels.forEach(function(panel) {
        panel.classList.remove('is-active');
      });

      tab.classList.add('is-active');

      const targetPanel = document.querySelector('.mecu-recommend-panel[data-panel="' + target + '"]');
      if (targetPanel) {
        targetPanel.classList.add('is-active');
      }
    });
  });


  /* ブランドタブ */
  const brandTabs = document.querySelectorAll('.mecu-brand-tab');
  const brandPanels = document.querySelectorAll('.mecu-brand-panel');

  brandTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const target = tab.dataset.tab;

      brandTabs.forEach(function(item) {
        item.classList.remove('is-active');
      });

      brandPanels.forEach(function(panel) {
        panel.classList.remove('is-active');
      });

      tab.classList.add('is-active');

      const targetPanel = document.querySelector('.mecu-brand-panel[data-panel="' + target + '"]');
      if (targetPanel) {
        targetPanel.classList.add('is-active');
      }
    });
  });


  /* 季節タブ */
  const seasonSections = document.querySelectorAll('.mecu-season-top');

  seasonSections.forEach(function(section) {
    const seasonTabs = section.querySelectorAll('.mecu-season-top-tab');
    const seasonPanels = section.querySelectorAll('.mecu-season-top-panel');

    seasonTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const target = tab.dataset.season;

        seasonTabs.forEach(function(item) {
          item.classList.remove('is-active');
        });

        seasonPanels.forEach(function(panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');

        const targetPanel = section.querySelector('.mecu-season-top-panel[data-season-panel="' + target + '"]');
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  });

});